import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Grid,
  Divider as MuiDivider,
  Typography as MuiTypography,
  TableContainer,
  Box,
} from "@mui/material";
import useAuth from "../../../hooks/useAuth";
import useTenant from "../../../hooks/useTenant";
import {
  ButtonBase,
  Button,
  Paper,
  TableBody,
  Table,
  TableCell as MuiTableCell,
  TableRow as MuiTableRow,
} from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { spacing } from "@mui/system";
import useUser from "../../../hooks/useUser";
import { useDialog } from "../../../contexts/DialogContext";

const Divider = styled(MuiDivider)(spacing);

const Typography = styled(MuiTypography)(spacing);

const theme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          paddingBottom: "0px", // Adjust this to control row spacing
          paddingTop: "4px",
          lineHeight: "1.2",
        },
      },
    },
  },
});

const Img = styled("img")({
  margin: "auto",
  display: "block",
  maxWidth: "100%",
  maxHeight: "100%",
});

const TableCell = styled(MuiTableCell)`
  padding-top: 0;
  padding-bottom: 0;
`;

const TableRow = styled(MuiTableRow)`
  height: 42px;

  &:last-child th,
  &:last-child td {
    border-bottom: 0;
  }
`;

const useTabStyles = styled({
  root: {
    justifyContent: "center",
    width: "1000px",
  },
  scroller: {
    flexGrow: "0",
  },
});

const convertNumberToWords = (amount) => {
  var words = new Array();
  words[0] = "";
  words[1] = "One";
  words[2] = "Two";
  words[3] = "Three";
  words[4] = "Four";
  words[5] = "Five";
  words[6] = "Six";
  words[7] = "Seven";
  words[8] = "Eight";
  words[9] = "Nine";
  words[10] = "Ten";
  words[11] = "Eleven";
  words[12] = "Twelve";
  words[13] = "Thirteen";
  words[14] = "Fourteen";
  words[15] = "Fifteen";
  words[16] = "Sixteen";
  words[17] = "Seventeen";
  words[18] = "Eighteen";
  words[19] = "Nineteen";
  words[20] = "Twenty";
  words[30] = "Thirty";
  words[40] = "Forty";
  words[50] = "Fifty";
  words[60] = "Sixty";
  words[70] = "Seventy";
  words[80] = "Eighty";
  words[90] = "Ninety";
  amount = amount.toString();
  var atemp = amount.split(".");
  var number = atemp[0].split(",").join("");
  var n_length = number.length;
  var words_string = "";
  if (n_length <= 9) {
    var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
    var received_n_array = new Array();
    for (var i = 0; i < n_length; i++) {
      received_n_array[i] = number.substr(i, 1);
    }
    for (var i = 9 - n_length, j = 0; i < 9; i++, j++) {
      n_array[i] = received_n_array[j];
    }
    for (var i = 0, j = 1; i < 9; i++, j++) {
      if (i == 0 || i == 2 || i == 4 || i == 7) {
        if (n_array[i] == 1) {
          n_array[j] = 10 + parseInt(n_array[j]);
          n_array[i] = 0;
        }
      }
    }
    var value = "";
    for (var i = 0; i < 9; i++) {
      if (i == 0 || i == 2 || i == 4 || i == 7) {
        value = n_array[i] * 10;
      } else {
        value = n_array[i];
      }
      if (value != 0) {
        words_string += words[value] + " ";
      }
      if ((i == 1 && value != 0) || (i == 0 && value != 0 && n_array[i + 1] == 0)) {
        words_string += "Crores ";
      }
      if ((i == 3 && value != 0) || (i == 2 && value != 0 && n_array[i + 1] == 0)) {
        words_string += "Lakhs ";
      }
      if ((i == 5 && value != 0) || (i == 4 && value != 0 && n_array[i + 1] == 0)) {
        words_string += "Thousand ";
      }
      if (i == 6 && value != 0 && n_array[i + 1] != 0 && n_array[i + 2] != 0) {
        words_string += "Hundred and ";
      } else if (i == 6 && value != 0) {
        words_string += "Hundred ";
      }
    }
    words_string = words_string.split("  ").join(" ");
  }
  return words_string;
};

function ReceiptForm({ renewId }) {
  const { unSetDialog } = useDialog();
  const [logoSrc, setLogoSrc] = useState(null);
  const { getTenantInvoiceLogo, tenantInvoiceLogo } = useTenant();

  const { getRenewal, renewal } = useUser();

  const handlePrint = () => {
    window.print();
  };

  console.log(renewal, "renewal");

  const handleCancel = () => {
    // Replace with your desired cancel functionality
    console.log("Cancel button clicked");
  };

  const fetchData = async () => {
    await getRenewal(renewId);
  };

  useEffect(() => {
    fetchData();
  }, [renewId]);

  const fetchTenantInvoiceLogo = async (tenantId) => {
    try {
      await getTenantInvoiceLogo(tenantId);
    } catch (error) {
      console.warn("Failed to fetch tenant invoice logo:", error);
    }
  };

  useEffect(() => {
    if (tenantInvoiceLogo != null) {
      const imageUrl = URL.createObjectURL(tenantInvoiceLogo);
      setLogoSrc(imageUrl);
    }
  }, [tenantInvoiceLogo]);

  useEffect(() => {
    console.log(renewal, "tenanttenant");
    if (Object.keys(renewal).length != 0) {
      fetchTenantInvoiceLogo(renewal?.msoTenantId);
    }
  }, [renewal]);

  return (
    <>
      <style>
        {`
  @media print {
    body * {
      visibility: hidden;
    }

    #print-receipt, #print-receipt * {
      visibility: visible;
    }

    #print-receipt {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
    }
  }
`}
      </style>
      <Paper
        id="print-receipt"
        elevation={3}
        sx={{
          backgroundColor: "#ffffff",
          padding: "32px",
          fontFamily: "'Roboto', sans-serif",
          maxWidth: "800px",
          margin: "auto",
        }}
      >
        {/* Header Section */}
        <Grid container justifyContent="space-between" alignItems="flex-start">
          <Grid item xs={8}>
            <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1 }}>
              Receipt
            </Typography>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 0.5 }}>
              {renewal?.msoName}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {renewal?.msoAddress1},
              <br />
              {renewal?.msoAddress2},
              <br />
              {renewal?.msoAddress3}
              <br />
              {renewal?.zipCode ? `${renewal.zipCode}` : ""}
            </Typography>
          </Grid>
          <Grid item xs={4} sx={{ textAlign: "right" }}>
            {logoSrc && (
              <Box
                component="img"
                src={logoSrc}
                alt="Company Logo"
                sx={{ maxWidth: "150px", maxHeight: "80px", objectFit: "contain" }}
              />
            )}
          </Grid>
        </Grid>

        {/* Success Icon & Amount Section */}
        <Box sx={{ textAlign: "center", mt: 4, mb: 4 }}>
          {/* Placeholder for Check Icon if needed, using generic unicode or simple circle for now if icon not imported */}
          <Box
            sx={{
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              width: 60,
              height: 60,
              borderRadius: "50%",
              border: "3px solid #000",
              mb: 1,
            }}
          >
            <Typography variant="h4" sx={{ color: "#000", fontWeight: "bold" }}>
              ✓
            </Typography>
          </Box>
          <Typography variant="h3" sx={{ fontWeight: "bold", color: "#000", mb: 0.5 }}>
            ₹{parseFloat(renewal?.finalInvoiceAmount || 0).toFixed(2)}
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{ color: "#00C853", fontWeight: "bold", textTransform: "uppercase" }}
          >
            Received Successfully
          </Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            Receipt No: {renewal?.receiptNo}
          </Typography>
        </Box>

        {/* Details Table */}
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{ border: "1px solid #000", borderRadius: 0, mb: 3 }}
        >
          <Table size="medium">
            <TableBody>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    width: "50%",
                    color: "#2962FF",
                    fontWeight: "bold",
                  }}
                >
                  Invoice No
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    borderBottom: "1px solid #000",
                    width: "50%",
                    color: "#2962FF",
                    fontWeight: "bold",
                  }}
                >
                  {renewal?.invoiceNo || renewal?.receiptNo}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    color: "#2962FF",
                    fontWeight: "bold",
                  }}
                >
                  Received From
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    borderBottom: "1px solid #000",
                    color: "#2962FF",
                    fontWeight: "bold",
                  }}
                >
                  {renewal?.fullName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    color: "#2962FF",
                    fontWeight: "bold",
                  }}
                >
                  Subscriber Name
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    borderBottom: "1px solid #000",
                    color: "#2962FF",
                    fontWeight: "bold",
                  }}
                >
                  {renewal?.fullName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    color: "#2962FF",
                    fontWeight: "bold",
                  }}
                >
                  Amount
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    borderBottom: "1px solid #000",
                    color: "#2962FF",
                    fontWeight: "bold",
                  }}
                >
                  ₹{parseFloat(renewal?.finalInvoiceAmount || 0).toFixed(2)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    color: "#2962FF",
                    fontWeight: "bold",
                  }}
                >
                  Balance
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    borderBottom: "1px solid #000",
                    color: "#2962FF",
                    fontWeight: "bold",
                  }}
                >
                  NIL
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: "1px solid #000",
                    color: "#2962FF",
                    fontWeight: "bold",
                  }}
                >
                  Paid On
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    borderBottom: "1px solid #000",
                    color: "#2962FF",
                    fontWeight: "bold",
                  }}
                >
                  {renewal?.receiptDate}
                </TableCell>
              </TableRow>
              <TableRow sx={{ borderBottom: 0 }}>
                <TableCell
                  sx={{
                    borderRight: "1px solid #000",
                    borderBottom: 0,
                    color: "#2962FF",
                    fontWeight: "bold",
                  }}
                >
                  Payment Mode
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ borderBottom: 0, color: "#2962FF", fontWeight: "bold" }}
                >
                  {renewal?.paymentType
                    ? renewal.paymentType === "ONLINE" || renewal.paymentType === "ON"
                      ? "Online"
                      : renewal.paymentType === "CASH" || renewal.paymentType === "CA"
                        ? "Cash"
                        : renewal.paymentType === "CHEQUE" || renewal.paymentType === "CH"
                          ? "Cheque"
                          : renewal.paymentType
                    : renewal?.renewalType === "ONLINE" ||
                        renewal?.renewalType === "ONLINE_SCHEDULE"
                      ? "Online"
                      : "Cash"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {/* Footer Section */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="body1" paragraph>
            Amount collected (in words):{" "}
            <span style={{ textDecoration: "underline" }}>
              {convertNumberToWords(renewal?.finalInvoiceAmount || 0)} Only
            </span>
          </Typography>
          <Typography variant="body1">
            Towards Subscription for the Pack{" "}
            <span style={{ fontWeight: "bold" }}>{renewal?.planName}</span> and Plan{" "}
            <span style={{ fontWeight: "bold" }}>{renewal?.rateName || "Yearly"}</span> for the sum
            of Rupees{" "}
            <span style={{ fontWeight: "bold" }}>
              ₹{parseFloat(renewal?.finalInvoiceAmount || 0).toFixed(2)}
            </span>
          </Typography>
        </Box>
      </Paper>

      <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 3, padding: "16px" }}>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            onClick={handlePrint}
            sx={{ fontWeight: "bold", backgroundColor: "#2962FF" }}
          >
            PRINT
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => unSetDialog("receipt")}
            sx={{ fontWeight: "bold" }}
          >
            CLOSE
          </Button>
        </Grid>
      </Grid>
    </>
  );
}

export default ReceiptForm;
